<template>
  <b-modal class="siteresponsemodal"  ref="siteresponsemodal" centered :lazy="true" title="Website response" :hide-footer="true" @shown="loadSiteReponse">
    <div class="loading-wrapper" v-if="isLoading">
      <spinner size="medium" message="Loading..."></spinner>
    </div>
    <div v-if="!isLoading" class="sitereponse-container" v-html="siteResponse">

    </div>
  </b-modal>
</template>

<script>
export default {
  name: "sitereponse",
  props: ["history"],
  data() {
    return {
      siteResponse: "",
      isLoading: false
    };
  },
  methods: {
    loadSiteReponse() {
      this.isLoading = true;
      let payload = {
        requiredData: {
          getResponseMoreInfo: this.history.historyID
        }
      };

      this.$store.dispatch("sendAction", payload).then(response => {
        this.siteResponse = response.data.getResponseMoreInfo;
        this.isLoading = false;
        if (!this.siteResponse) {
          this.siteResponse = "No additional website response available.";
        }
      });
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/SiteResponse.vue